import styled from '@emotion/styled';
import React from 'react';
import { Typography } from './Typography';
import { MdReport } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import { useAccount } from '../../../../../context/AccountContext';

interface SidebarFooterProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  collapsed?: boolean;
}

const StyledButton = styled.a`
  padding: 5px 16px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  display: inline-block;
  background-color: #fff;
  color: #484848;
  text-decoration: none;
`;

const StyledSidebarFooter = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-radius: 8px;
  color: white;
  background: linear-gradient(45deg, rgb(21 87 205) 0%, rgb(90 225 255) 100%);
`;

const StyledCollapsedSidebarFooter = styled.a`
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  color: white;
  background: linear-gradient(45deg, rgb(21 87 205) 0%, rgb(90 225 255) 100%);
`;

const FreePlanButton = styled.button`
  background-color: #0071e1;
  color: white;
  border: 1px solid #0071e1;
  padding: 8px 16px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    background-color: #005cbf;
    border-color: #005cbf;
  }
`;

const codeUrl = 'https://github.com/azouaoui-med/react-pro-sidebar/blob/master/storybook/Playground.tsx';

export const SidebarFooter: React.FC<SidebarFooterProps> = ({ children, collapsed, ...rest }) => {
  const history = useHistory();
   const {activePlan} = useAccount()
  // const activePlan='free'
  const handleUpgradeClick = () => {
    history.push('/settings/edit-plan');
  }
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingBottom: '20px',
      }}>
      {collapsed ? (
        <MdReport />
      ) : (
        <>

          <Typography fontWeight={500} style={{ marginTop: '10px' }}>Current Plan: {activePlan.product_plan}</Typography>
          {activePlan.product_plan === 'free' && (
          <div style={{ marginTop: '16px' }}>
            <FreePlanButton  onClick={handleUpgradeClick}>
              Upgrade Plan ({activePlan.daysLeft} days left)
            </FreePlanButton>
          </div>
            )}
        </>
      )}
    </div>
  );
};